export default __webpack_public_path__ + "static/media/facebook.a00edd68.jpg";